module.exports = __webpack_public_path__ + "js/0.4a0d4e0e.worker.js"